import { AlphaABoxOutlineIcon } from './AlphaABoxOutlineIcon';

/**
 * author: Contributors
 * id B501FBBD-91FA-4567-8D4A-BD933FECCE7B
 * name alpha-a-box-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-a-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterABoxOutlineIcon = AlphaABoxOutlineIcon;
export default LetterABoxOutlineIcon